import { Pipe, PipeTransform } from '@angular/core';

import { ColumnProgressBarConfig } from '@blaze-shared/elements-domain';
import { valueToPercent } from '@blaze-shared/shared-util';

@Pipe({
  name: 'progressBarSegment',
})
export class ProgressBarSegmentPipe implements PipeTransform {
  transform(
    value: any,
    config: ColumnProgressBarConfig | undefined,
    isColumnPercent: boolean,
    extremes: { min: number; max: number },
  ): {
    width: number;
    color: string;
  } {
    const thresholds = config?.colorScale;
    if (!config || !thresholds?.length) {
      return { width: 0, color: '' };
    }

    const numValue = typeof value !== 'number' ? Number(value) : value;
    if (isNaN(numValue)) {
      return { width: 0, color: thresholds[0].color.color1 };
    }

    const minValue = extremes.min;
    const maxValue = extremes.max;
    const unit = config.colorScaleUnit;
    const rangeDiff = maxValue - minValue;
    let valuePct = 0;
    if (rangeDiff !== 0) {
      const factor = isColumnPercent ? 100 : 1;
      valuePct = Math.min(100, Math.max(0, ((numValue * factor - minValue) * 100) / rangeDiff));
    }

    let color = thresholds[thresholds.length - 1].color.color1;
    for (let i = 0; i < thresholds.length - 1; i++) {
      const boundaryPct = valueToPercent(thresholds[i].value, unit, minValue, maxValue);
      if (valuePct <= boundaryPct) {
        color = thresholds[i].color.color1;
        break;
      }
    }

    return { width: valuePct, color };
  }
}
